module.exports = __webpack_public_path__ + "media/images/front/icons/calendar-0d9af528ef510c2e97efa55ea1dcd491.png";